import { formatUKPostcode } from './geolocation';

// This is an initial validation that excludes clearly invalid postcodes.
// Passing this check does not guarantee the postcode is actually valid.
//  It is meant as a typo-check for the user.
// http://en.wikipedia.org/wiki/Postcodes_in_the_United_Kingdom#Validation
const postCodeRegex = {
  UK: /^(GIR0AA)|(((A[BL]|B[ABDFHLNRSTX]?|C[ABFHMORTVW]|D[ADEGHLNTY]|E[HNX]?|F[KY]|G[LUY]?|H[ADGPRSUX]|I[GMPV]|JE|K[ATWY]|L[ADELNSU]?|M[EKL]?|N[EGNPRW]?|O[LX]|P[AEHLOR]|R[GHM]|S[AEGKLMNOPRSTY]?|T[ADFNQRSW]|UB|W[ADFNRSV]|YO|ZE)[1-9]?[0-9]|((E|N|NW|SE|SW|W)1|EC[1-4]|WC[12])[A-HJKMNPR-Y]|(SW|W)([2-9]|[1-9][0-9])|EC[1-9][0-9])[0-9][ABD-HJLNP-UW-Z]{2})$/i,
  NL: /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/,
  BE: /^[0-9]{4}$/,
};

export function validatePostcode(postcode, country) {
  const postcodeRegex = postCodeRegex[country.toUpperCase()];
  return postcode.replace(/\s+/g, '').match(postcodeRegex) != null;
}

export function shortAddress({ tld, isPostcodeSearch, postcode, neighborhood }) {
  switch (true) {
    case tld === 'uk':
      return formatUKPostcode(postcode) || '';
    case isPostcodeSearch:
      return postcode;
    default:
      return neighborhood;
  }
}
